import React from "react"
import SlateNode from "../../slate-node"

// Wrapper for final embed
export const Spotify = ({
  children,
  attributes,
  href,
  alignment = "left",
  node
}) => {
  return (
    <SlateNode
      {...attributes}
      as="table"
      node={node}
      style={{
        borderCollapse: "collapse",
        padding: "0",
        width: "100%"
      }}
    >
      <tbody>
        <tr style={{ height: "80px" }}>
          <td align={alignment} style={{ height: "80px" }}>
            <a
              style={{ textDecoration: "none" }}
              href={href}
              onClick={event => event.preventDefault()}
            >
              {children}
            </a>
          </td>
        </tr>
      </tbody>
    </SlateNode>
  )
}

export default Spotify
